var mena = window.mena || {};

(function ($) {
    'use strict';

    mena.main.init = function () {
        mena.main.stickyHeader();
        mena.main.headerSubmenuHoverClass();
        mena.main.mobileMenu();
        mena.main.svg4everybody();
        mena.main.loadAssets();
        mena.main.heroScroll();
        mena.main.newsArchive();
        mena.main.toggleSocials();
        mena.main.animations();
    };

    mena.main.animations = function () {
        gsap.registerPlugin('scrollTrigger');
        ScrollTrigger.batch("[data-animation='fade-up']", {
            interval: 0.1, // time window (in seconds) for batching to occur.
            batchMax: 10,
            onEnter: (batch) =>
                gsap.to(batch, {
                    opacity: 1,
                    y: 0,
                    stagger: { each: 0.15 },
                    ease: 'back.inOut(0.5)',
                    overwrite: true,
                    duration: 0.8,
                }),

            start: '20px bottom',
            end: 'top top',
        });


        ScrollTrigger.create({
            trigger: ".image-title-cta__right",
            start: "top 90%",
            toggleClass: "active"
        });
        ScrollTrigger.create({
            trigger: ".title-cta__wrapper",
            start: "top 70%",
            toggleClass: "active"
        });
    };

    mena.main.loadAssets = function () {
        if ($('.hero-slider__swiper').length > 0) {
            loadjs(menaObject.assets + '/js/swiper.min.js', function () {
                mena.main.heroSliderSwiper();
            });
        }

        if ($('.tabs__accordion').length > 0) {
            mena.main.tabs();
        }
    };

    mena.main.tabs = function () {
        $('.tabs__accordion').each(function () {
            var $accordion = $(this);
            var $section = $accordion.closest('.tabs');
            var $images = $section.find('.tabs__image');

            $accordion.find('.tabs__panel.is-active').each(function () {
                var $body = $(this).find('.tabs__panel-body');
                $body.css('max-height', $body[0].scrollHeight + 'px');
            });

            $accordion.find('.tabs__panel-header').on('click', function () {
                var $panel = $(this).closest('.tabs__panel');
                var index = $panel.data('tab-panel');

                if ($panel.hasClass('is-active')) {
                    // At least one tab must stay open — do not close the active panel
                    return;
                }

                $accordion.find('.tabs__panel.is-active').each(function () {
                    $(this).removeClass('is-active');
                    $(this).find('.tabs__panel-body').css('max-height', 0);
                });

                $panel.addClass('is-active');
                var $body = $panel.find('.tabs__panel-body');
                $body.css('max-height', $body[0].scrollHeight + 'px');

                $images.removeClass('is-active');
                $images.filter('[data-tab-image="' + index + '"]').addClass('is-active');
            });
        });
    };

    mena.main.newsArchive = function () {
        if (!$('.news').length) return;

        $('.news__tab').on('click', function () {
            if (!$(this).hasClass('active')) {
                $('.news__tab.active').removeClass('active');
                $(this).addClass('active');
                var category = $(this).data('category');
                getPosts(1, category);
            }
        });

        $(document).on('click', '.pagination__prev:not(.disabled)', function () {
            var currentPage = Number($('.news-current-page').val());
            var category = $('.news__tab.active').data('category');
            if (currentPage > 1) {
                getPosts(currentPage - 1, category);
            }
        });

        $(document).on('click', '.pagination__next:not(.disabled)', function () {
            var currentPage = Number($('.news-current-page').val());
            var maxPages = Number($('.news-max-pages').val());
            var category = $('.news__tab.active').data('category');
            if (currentPage < maxPages) {
                getPosts(currentPage + 1, category);
            }
        });

        $(document).on('click', '.pagination__page:not(.active):not(.ellipsis)', function () {
            var page = Number($(this).data('page'));
            var category = $('.news__tab.active').data('category');
            getPosts(page, category);
        });

        function newsPaginationItems(current, max) {
            max = Math.max(0, max | 0);
            if (max <= 0) {
                return [];
            }
            current = Math.max(1, Math.min(current | 0, max));

            if (max <= 7) {
                var all = [];
                for (var n = 1; n <= max; n++) {
                    all.push(n);
                }
                return all;
            }

            var delta = 2;
            var range = [];
            var i;
            for (i = 1; i <= max; i++) {
                if (
                    i === 1 ||
                    i === max ||
                    (i >= current - delta && i <= current + delta)
                ) {
                    range.push(i);
                }
            }

            var out = [];
            var l = null;
            range.forEach(function (num) {
                if (l !== null) {
                    if (num - l === 2) {
                        out.push(l + 1);
                    } else if (num - l !== 1) {
                        out.push('ellipsis');
                    }
                }
                out.push(num);
                l = num;
            });
            return out;
        }

        function buildPagination(current, max) {
            var items = newsPaginationItems(current, max);

            var $pages = $('.pagination__pages');
            $pages.empty();
            items.forEach(function (item) {
                if (item === 'ellipsis') {
                    $pages.append(
                        '<span class="pagination__page ellipsis" aria-hidden="true">...</span>'
                    );
                } else {
                    $pages.append(
                        '<button type="button" class="pagination__page' +
                            (item === current ? ' active' : '') +
                            '" data-page="' +
                            item +
                            '">' +
                            item +
                            '</button>'
                    );
                }
            });

            if (current > 1) {
                $('.pagination__prev').removeClass('disabled');
            } else {
                $('.pagination__prev').addClass('disabled');
            }
            if (current < max) {
                $('.pagination__next').removeClass('disabled');
            } else {
                $('.pagination__next').addClass('disabled');
            }

            if (max <= 1) {
                $('.pagination').hide();
            } else {
                $('.pagination').show();
            }
        }

        function getPosts(paginationNumber, category) {
            $.ajax({
                type: 'POST',
                url: menaObject.ajaxurl,
                dataType: 'html',
                data: {
                    action: 'get_news',
                    paginationNumber: paginationNumber,
                    category: category,
                },

                beforeSend: function () {
                    $('.news__posts').addClass('loading');
                },

                success: function (response) {
                    $('.news__posts').html(response);
                    $('.news__posts').removeClass('loading');

                    var currentPage = Number($('.news-current-page').val());
                    var maxPages = Number($('.news-max-pages').val());

                    buildPagination(currentPage, maxPages);

                    ScrollTrigger.batch("[data-animation='fade-up']", {
                        interval: 0.1,
                        batchMax: 10,
                        onEnter: function (batch) {
                            gsap.to(batch, {
                                opacity: 1,
                                y: 0,
                                stagger: { each: 0.15 },
                                ease: 'back.inOut(0.5)',
                                overwrite: true,
                                duration: 0.8,
                            });
                        },
                        start: '20px bottom',
                        end: 'top top',
                    });

                    var tabs = document.querySelector('.news__tabs');
                    if (tabs) tabs.scrollIntoView({ behavior: 'smooth' });
                },
            });
        }
    };

    mena.main.heroScroll = function () {
        $('.hero-slider__scroll-to-content').click(function () {
            var target = $(this).closest('section').next('section');

            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $(target).offset().top,
                },
                500
            );
        });
    };

    mena.main.heroSliderSwiper = function () {
        var heroSwiper = new Swiper(".hero-slider__swiper", {
					autoplay: {
						delay: 5000,
					},
					loop: true,
					spaceBetween: 30,

					speed: 500,
					navigation: {
						nextEl: ".hero-slider .hero-slider__next",
						prevEl: ".hero-slider .hero-slider__prev",
					},
				});
    };

    mena.main.svg4everybody = function () {
        svg4everybody();
    };

    mena.main.mailchimp = function () {
        if ($('.js-mailchimp').length > 0) {
            loadjs(
                menaObject.assets + '/js/mailchimp-validate.js',
                function () {
                    window.fnames = new Array();
                    window.ftypes = new Array();
                    fnames[0] = 'EMAIL';
                    ftypes[0] = 'email';
                }
            );
        }
    };

    mena.main.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this,
                args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    mena.main.stickyHeader = function () {
        var stickyHeader = function () {
            var header = $('#header');

            if ($(window).scrollTop() > 1) {
                header.addClass('sticky');
            } else {
                header.removeClass('sticky');
            }
        };

        window.addEventListener('load', stickyHeader);
        window.addEventListener(
            'scroll',
            mena.main.debounce(stickyHeader, 5)
        );
        window.addEventListener(
            'resize',
            mena.main.debounce(stickyHeader, 150)
        );
    };

    /**
     * Desktop main nav: toggle #header.is-hovering while pointer is over a top-level item with children (including its submenu).
     */
    mena.main.headerSubmenuHoverClass = function () {
        var $header = $('#header');
        var $mainMenu = $header.find('.menu--main-menu');

        if (!$mainMenu.length) {
            return;
        }

        $mainMenu.on('mouseenter', '> .menu-item-has-children', function () {
            $header.addClass('is-hovering');
        });

        $mainMenu.on('mouseleave', '> .menu-item-has-children', function () {
            $header.removeClass('is-hovering');
        });
    };

    mena.main.mobileMenu = function () {
        var respMenu = $('.resp-menu');
        var button = $('.js-menu-toggle');
        var body = $('body');

        button.click(function (e) {
            body.toggleClass('menu-open');
            button.toggleClass('menu-toggle--active');
        });

        /* Sliding side menu, close on swipe */
        if ($().swipe) {
            respMenu.swipe({
                swipeRight: function (
                    event,
                    direction,
                    distance,
                    duration,
                    fingerCount
                ) {
                    body.removeClass('menu-open');
                },
                threshold: 20,
                excludedElements: '',
            });
            button.swipe({
                swipeLeft: function (
                    event,
                    direction,
                    distance,
                    duration,
                    fingerCount
                ) {
                    body.addClass('menu-open');
                },
                threshold: 20,
                excludedElements: '',
            });
        }

        /* Toggle sub-menu on click for parent items with children */
        respMenu.find('.menu-item-has-children > a').on('click', function (e) {
            var $parent = $(this).parent();
            var $sub = $parent.children('.sub-menu');

            if (!$parent.hasClass('sub-open')) {
                e.preventDefault();
                respMenu.find('.menu-item-has-children').not($parent).removeClass('sub-open').children('.sub-menu').slideUp(300);
                $parent.addClass('sub-open');
                $sub.slideDown(300);
            }
        });
    };

    mena.main.toggleSocials = function () {
        $('.single-post__share').on('click', function () {
            if ($('.single-post__socials').hasClass('active')) {
                $('.single-post__socials').removeClass('active');
            } else {
                $('.single-post__socials').addClass('active');
            }
        });
    };

    return mena.main.init();
})($);
0;
